import { getHeadersWithUniqueVisitorId } from "@brandclub/common-ui";
import { HOST_DOMAIN } from "../../utils/domain";
import { ThemeOptions } from "@mui/material";

const DOMAIN = `${HOST_DOMAIN}/api-rewards`;

export interface UpdateSetupThemeConfig {
  colorOptions: string[];
  fontFamilyOptions: string[];
  appId: string;
  setupId: string;
  theme: ThemeOptions;
}

type UpdateSetupThemeResponse =
  | {
      status: "success";
      colorOptions: string[];
      fontOptions: string[];
      configId: string;
      setupId: string;
      theme: ThemeOptions;
    }
  | {
      status: "failed";
      errorMessage: string;
    };

export const updateSetupTheme = async (setupConfig: UpdateSetupThemeConfig) => {
  const headers = await getHeadersWithUniqueVisitorId();
  const res = await fetch(DOMAIN + `/brandapp/themeSetup`, {
    method: "POST",
    headers,

    body: JSON.stringify(setupConfig),
  });
  if (!res.ok) {
    throw new Error("Error updating theme setup");
  }
  const data: UpdateSetupThemeResponse = await res.json();
  if (data.status !== "success") {
    throw new Error(data.errorMessage);
  }
  return data;
};
